import React from 'react';
import cn from '@/utils/cn';
import I18n from 'i18n-js';

interface NumberBadgeProps {
  color: string;
  location: 'unitCard' | 'unitHeader' | 'lessonCard';
  number: number;
}

const NumberBadge = ({ color, location, number }: NumberBadgeProps) => (
  <div
    className={cn('tw-absolute tw-z-[10] tw-bg-white tw-flex tw-flex-col tw-items-center tw-justify-center', {
      'tw-h-[4.5rem] tw-w-[6rem] tw-rounded-tl-lg tw-rounded-br-2xl': location === 'lessonCard',
      'tw-left-2 tw-top-2': location === 'unitCard',
      'tw-size-[4.5rem] tw-rounded-full tw-border-2 tw-border-solid tw-border-med-grey': location !== 'lessonCard',
    })}
    style={{
      boxShadow: (location === 'lessonCard' ? '2px 2px 4px rgba(0,0,0,0.2)' : '0px 0px 4px rgba(0,0,0,0.35)'),
      color: `#${color}`,
    }}
  >
    <span className={cn('tw-text-[16px] tw-font-medium', { 'tw-mt-2': location !== 'lessonCard' })}>
      {location === 'lessonCard' ? I18n.t('lesson') : I18n.t('unit')}
    </span>
    <span className="tw-text-3xl tw-font-semibold">
      {number}
    </span>
  </div>
);

export default NumberBadge;
